import { render } from "./PriceComponent.vue?vue&type=template&id=7209bad2&scoped=true&ts=true"
import script from "./PriceComponent.vue?vue&type=script&lang=ts"
export * from "./PriceComponent.vue?vue&type=script&lang=ts"

import "./PriceComponent.vue?vue&type=style&index=0&id=7209bad2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7209bad2"]])

export default __exports__